import { render, staticRenderFns } from "./BaseFormItem2.vue?vue&type=template&id=d78f8b6a&scoped=true"
import script from "./BaseFormItem2.vue?vue&type=script&lang=js"
export * from "./BaseFormItem2.vue?vue&type=script&lang=js"
import style0 from "./BaseFormItem2.vue?vue&type=style&index=0&id=d78f8b6a&prod&lang=scss&scoped=true"
import style1 from "./BaseFormItem2.vue?vue&type=style&index=1&id=d78f8b6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d78f8b6a",
  null
  
)

export default component.exports